import {useQuery, UseQueryOptions} from '@tanstack/react-query'
import {captureException} from '@sentry/react'
import {parseAxiosPromise} from '@/axiosInstance.ts'
import {QUERY_KEYS} from '@/queryClient.ts'
import {ResponseType} from '@/types.ts'
import {httpGetRequiredActions} from '@features/home/http/home.http.ts'
import {RequiredActions} from '@features/home/types.ts'

export const useRequiredActions = (options?: Omit<UseQueryOptions<RequiredActions>, 'queryKey' | 'queryFn'>) => {
    return useQuery({
        queryKey: [QUERY_KEYS.REQUIRED_ACTIONS],
        queryFn: () =>
            parseAxiosPromise({
                axiosPromise: httpGetRequiredActions({
                    params: {response_type: ResponseType.Enum.extended}
                }),
                onZodError: captureException,
                responseShape: RequiredActions
            }),
        ...options
    })
}
